<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-sm-5">
                    {{trans('users.cards.header.hours')}} - {{actual_month}}
                </div>
                <div class="col-sm-7 text-right">
                    <el-button-group>
                        <el-button size="mini" icon="el-icon-arrow-left" @click="handlePrevious" plain>
                            {{previous_month}}
                        </el-button>
                        <el-button size="mini" @click="handleNext" plain>{{next_month}}<i
                                class="el-icon-arrow-right el-icon-right"></i></el-button>
                    </el-button-group>
                </div>
            </div>

        </div>
        <div v-loading="loading > 0" class="card-body">
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-sm">
                        <thead>
                        <tr>
                            <th>{{trans('users.fields.capacity')}}</th>
                            <th>{{trans('users.fields.allocate_hours')}}</th>
                            <th>{{trans('users.fields.spent_hours')}}</th>
                            <th>{{trans('users.fields.free_hours')}}</th>
                            <th>{{trans('users.fields.real_free_hours')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{capacityHours}}</td>
                            <td><a :href="tasksHref" target="_blank">{{allocateHours}}</a></td>
                            <td>{{spentHours}}</td>
                            <td>{{freeHours}}</td>
                            <td>{{realFreeHours}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let moment = require('moment');
    import _ from 'lodash';

    export default {
        name: "user-hours",
        props: {
            user: Object,
        },
        data() {
            return {
                contracts: [],
                tasks: [],
                loading: 0,
                actualMonth: moment().get('month'),
                actualYear: moment().get('year'),
                capacity: [],
            }
        },
        computed: {
            tasksHref(){
              return laroute.route('tasks', {user: this.user.id, ids: _.map(this.tasksThisMonth, 'id')});
            },
            actual_month() {
                return moment([this.actualYear, this.actualMonth, 1]).format('MM/YYYY');
            },
            previous_month() {
                return moment([this.actualYear, this.actualMonth, 1]).subtract(1, 'months').format('MM/YYYY');
            },
            next_month() {
                return moment([this.actualYear, this.actualMonth, 1]).add(1, 'months').format('MM/YYYY');
            },
            freeHours() {
                return this.capacityHours - this.allocateHours;
            },
            realFreeHours() {
                return this.allocateHours - this.spentHours;
            },
            spentHours() {
                return this.allocateHours - _.sumBy(this.tasksThisMonth, 'remaining_hours');
            },
            allocateHours() {
                return _.sumBy(this.tasksThisMonth, 'estimated_hours');
            },
            capacityHours() {
                if (this.capacity[this.actualYear] !== undefined && this.capacity[this.actualYear][this.actualMonth + 1] !== undefined) {
                    return this.capacity[this.actualYear][this.actualMonth + 1];
                }
                return 0;
            },
            tasksThisMonth() {
                let vm = this;
                let actualPivotMonth = moment([this.actualYear, this.actualMonth, 1]).endOf('month');
                return this.tasks.filter(function (task) {
                    // console.log(moment(task.deadline), moment(task.deadline).get('year'),  moment(task.deadline).get('month'));
                    return (moment(task.deadline).get('year') === vm.actualYear
                        && moment(task.deadline).get('month') === vm.actualMonth)
                        || (!task.done && !task.one_time && moment(task.deadline) < actualPivotMonth && moment(task.project.deadline) >= moment(actualPivotMonth));
                });
            },
        },
        mounted() {
            this.loadContracts();
            this.loadTasks();
            this.loadCapacity();
        },
        methods: {
            handlePrevious() {
                let newPivotDate = moment([this.actualYear, this.actualMonth, 1]).subtract(1, 'months');
                this.actualYear = newPivotDate.get('year');
                this.actualMonth = newPivotDate.get('month');
            },
            handleNext() {
                let newPivotDate = moment([this.actualYear, this.actualMonth, 1]).add(1, 'months');
                this.actualYear = newPivotDate.get('year');
                this.actualMonth = newPivotDate.get('month');
            },
            trans: function (path) {
                return Lang.trans(path);
            },
            loadContracts() {
                let vm = this;
                vm.loading++;
                axios.get(laroute.route('json.users.contracts', {user: this.user.id}))
                    .then(response => {
                        vm.loading--;

                        vm.contracts = response.data;
                    })
                    .catch(error => {
                        vm.loading--;

                        console.log(error);
                    });
            },
            loadTasks() {
                let vm = this;
                vm.loading++;
                axios.get(laroute.route('json.users.tasks', {user: this.user.id}))
                    .then(response => {
                        vm.loading--;

                        vm.tasks = response.data;
                    })
                    .catch(error => {
                        vm.loading--;

                        console.log(error);
                    });
            },
            loadCapacity() {
                let vm = this;
                vm.loading++;
                axios.get(laroute.route('json.users.capacity', {user: this.user.id}))
                    .then(response => {
                        vm.loading--;
                        vm.capacity = response.data;
                    })
                    .catch(error => {
                        vm.loading--;

                        console.log(error);
                    });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/users/UserHours.vue